import { jsx as o } from "react/jsx-runtime";
import p from "clsx";
import { forwardRef as u } from "react";
import { useMenuContext as a } from "../useMenuContext.js";
import { MenuDrawer as c } from "./MenuDrawer.js";
import t from "./MenuList.module.css.js";
import { useMenuList as l } from "./useMenuList.js";
const d = u(
  ({ children: e, placement: m = "bottom-start", fullWidth: r = !1, className: s }, n) => {
    const { opened: i } = a(), f = l({ placement: m }, n);
    return i ? /* @__PURE__ */ o(
      "div",
      {
        ...f,
        className: p(t.container, s, {
          [t.fullWidth]: r
        }),
        children: /* @__PURE__ */ o(c, { fullWidth: r, children: e })
      }
    ) : null;
  }
);
d.displayName = "MenuList";
export {
  d as MenuList
};
//# sourceMappingURL=MenuList.js.map
